import styled from 'styled-components'
import { TooltipProps } from '@elamajs/ui-kit'

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`

export const Label = styled.div`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 400;
`

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 15px;
`

export const Checkbox = styled.div`
  div[class^='Checkboxstyled__CheckboxContent'] {
    color: ${({ theme }) => theme.palette.black[20]};
    font-size: 14px;
  }

  div[class^='Checkboxstyled__Label'] {
    word-break: unset;
  }
`

export const Tooltip = styled.div<TooltipProps>`
  color: #292e3d;

  ~ div {
    z-index: 2;

    & > div {
      display: flex;
      flex-direction: column;
      row-gap: 20px;

      font-size: 12px;
      line-height: 18px;
      font-weight: 400;

      color: ${({ theme }) => theme.palette.black[50]};
    }
  }
`

export const Link = styled.a`
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;

  color: ${({ theme }) => theme.palette.black[60]};
`
